export const reduxKey = '@@addToGroups';
export const actionKey = '@@addToGroups';
export const groupFoldersStreamType = '@@groupfolders';
export const groupsStreamType = '@@groups';

//# sourceMappingURL=constants.js.map